// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/*.btn-date-picker {*/\n/*    font-size: 14px;*/\n/*    border: 1px solid #d1d1d1;*/\n/*    !*border-color: #d1d1d1;*!*/\n/*    background-color: #f4f4f5;*/\n/*    border-radius: 5px;*/\n/*}*/\n/*.middle {*/\n/*    display: inline;*/\n/*    marigin-left: 5px;*/\n/*    marigin-right: 5px;*/\n/*}*/\n", ""]);
// Exports
module.exports = exports;
